// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { ChangePasswordMessage } from '../Messages/ChangePasswordMessage';
import { MessageProcessorBase } from './MessageProcessorBase';
export class ChangePasswordMessageProcessor extends MessageProcessorBase {
    constructor(parentDecoder) {
        super();
        this.decoder = parentDecoder;
    }
    decode(fieldSet) {
        const message = new ChangePasswordMessage(fieldSet);
        return [message];
    }
}
